<!-- Last Module -->
<section *ngIf="!courseComplete && !quizStart">
    <!-- Title -->
    <div class="text-center">
        <h1>Module 10 - Neighborhood Wants</h1>
    </div>

    <!-- Module Content -->
    <div class="container content-box module-content text-center">
        <app-youtube-player #video src="https://www.youtube.com/embed/Lp-tq81AW0s" width="900" height="620" autoplay></app-youtube-player>
    </div>

    <!-- Navigation Buttons -->
      <div class="container navigate-buttons">
          <button type="button" class="btn waves-dark w-25" [routerLink]="'/module9-fhe'"><i class="fas fa-angle-left mr-3"></i>Previous</button>
          <button type="button" class="btn waves-dark w-25" (click)="startQuiz($event)" [delay-click]="video.duration / video.speed" [delay-until]="video.isCompleted" delay-tooltip="Watch the whole video to the end first."><i class="fas fa-angle-right mr-3"></i>Quiz</button>
      </div>
</section>

<!-- Quiz Mode -->
<section *ngIf="quizStart && !courseComplete">
    <app-quiz-questions [questions]="questions" [moduleNumber]="10" (quizSubmitted)="handleQuiz($event)"></app-quiz-questions>
</section>

<!-- Course Complete Page -->
<section *ngIf="courseComplete">

    <!-- Message -->
    <div class="text-center">
        <h1 style="margin-bottom: 20px;">Congratulations! You've completed Housing Provider Education.</h1>
        <h4 style="margin-bottom: 20px;" *ngIf="user.ageUnder18 !== true">You may now add any properties you own or manage. Click 'Add Properties' to get started.</h4>
        <h5 style="margin-bottom: 60px;">If you are a tenant who took this for your own education, Thank you for learning more, but no other action is needed.</h5>

        <!-- Navigation Buttons -->
        <div class="certificate-btns">
            <button type="button" class="btn waves-dark w-25" (click)="courseComplete = false"><i class="fas fa-angle-left mr-3"></i>Previous</button>
            <button type="button" class="btn waves-dark w-25" [routerLink]="'/properties'" *ngIf="user.ageUnder18 !== true">Add Properties<i class="fas fa-angle-right ml-3"></i></button>
        </div>
    </div>
</section>

<!-- Course Complete Page -->
<!-- <section *ngIf="courseComplete">


    <div class="text-center">
        <h1 style="margin-bottom: 20px;">Congratulations! You've completed Housing Provider Education.</h1>
        <h4 style="margin-bottom: 60px;">Click 'Get Certificate' to receive your personalized certificate.</h4>


        <div class="certificate-btns">
            <button type="button" class="btn waves-dark w-25" (click)="courseComplete = false"><i class="fas fa-angle-left mr-3"></i>Previous</button>
            <button type="button" class="btn waves-dark w-25" [routerLink]="'/certificate-fhe'">Get Certificate<i class="fas fa-angle-right ml-3"></i></button>
        </div>
    </div>
</section> -->
